import { useCallback, useState } from 'react';

import request from '@/services/request';

import { TInspection, TProperty } from './types';

export const useFetchProperties = () => {
  const [data, setData] = useState<TProperty[] | undefined>();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState();

  const fetchProperties = useCallback(async (status?: string) => {
    setLoading(true);
    try {
      const res = await request.get(`/property/simple/details${status ? `?status=${status}` : ''}`);
      setData(res.data);
    } catch (err: any) {
      setError(err);
    } finally {
      setLoading(false);
    }
  }, []);

  return { data, loading, error, fetchProperties };
};

export const useFetchInspectionAmenities = () => {
  const [data, setData] = useState<TInspection | undefined>();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState();

  const fetchInspectionAmenities = useCallback(async (property_code: string) => {
    setLoading(true);
    try {
      const res = await request.get(`/property/inspection/?property_code=${property_code}`);
      setData(res.data);
      return res.data;
    } catch (err: any) {
      setData(undefined);
      setError(err);
    } finally {
      setLoading(false);
    }

    return undefined;
  }, []);

  return { data, loading, error, fetchInspectionAmenities };
};

export const useSyncInspection = () => {
  const [success, setSuccess] = useState<boolean>();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState();

  const syncInspection = useCallback(async (property_code: string) => {
    setLoading(true);
    try {
      await request.post(`/channel_manager/pleno/sync/inspection`, { property_code });
      setSuccess(true);
    } catch (err: any) {
      setSuccess(false);
      setError(err);
    } finally {
      setLoading(false);
    }
  }, []);

  return { success, loading, error, syncInspection };
};
